export let GOOGLE_MAPS_API_KEY = import.meta.env.GOOGLE_MAPS_API_KEY;
export const ENDPOINT_PROPERTY_LISTINGS = import.meta.env.ENDPOINT_PROPERTY_LISTINGS;
if (!GOOGLE_MAPS_API_KEY) {
  GOOGLE_MAPS_API_KEY = typeof window !== 'undefined' && '__AY_MAPS_INIT__' in window && window['__AY_MAPS_INIT__'].GOOGLE_MAPS_API_KEY || 'GOOGLE MAP API KEY REQUIRED';
}
export const ACTIVE_DATASET = 'propertyListing'; /* (
                                                 (
                                                 typeof window !== 'undefined'
                                                 && '__AY_MAPS_INIT__' in window
                                                 && (window['__AY_MAPS_INIT__'] as any).FINDER_DATASET
                                                 )
                                                 || 'property-listings'
                                                 );*/